import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

/**
 * Styled cell container for table cells
 */
export const StyledCellBox = styled(Box)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(11),
}));

/**
 * Styled P&L box with error color support
 */
export const StyledPnLBox = styled(Box)<{ errorColor?: boolean }>(
  ({ theme, errorColor }) => ({
    fontFamily: 'var(--font-family-mono)',
    fontSize: theme.typography.pxToRem(11),
    fontWeight: theme.typography.fontWeightBold,
    color: errorColor ? theme.palette.error.main : '',
  }),
);

/**
 * Styled status box container for status column
 */
export const StyledStatusBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  fontSize: theme.typography.pxToRem(10),
  '& svg': {
    width: theme.typography.pxToRem(8),
    height: theme.typography.pxToRem(8),
  },
}));
